import {Component, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {OverlayMaterialColor} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-overlay-material-color-inspector",
    templateUrl: "./overlay-material-color-inspector.component.html",
    styleUrl: "./overlay-material-color-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class OverlayMaterialColorInspectorComponent extends BaseInspectorComponent<OverlayMaterialColor, {}> {}
